export default __webpack_public_path__ + "static/media/SILVER_ARTICLES.780a19be.png";